import { Images } from "../../../Images";
import BigNum from "../../math/BigNum";
import Values from "../../value/Values";
import UpgradePrestigeAutomationSkillNode from "./UpgradePrestigeAutomationSkillNode";
import { SkillIds } from "../SkillIds";
import SkillType from "../SkillType";
import AutomationUnlockSkillNode from "./AutomationUnlockSkillNode";

export default class PrestigeAutomationSkill extends SkillType {
    /**
     * @param {Totals} totals
     * @param {Values} values
     */
    constructor(totals, values) {
        super(SkillIds.PRESTIGE_AUTOMATION);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;

        const inc = 5;
        let cost = 10;

        const prestigeAutomationUnlock = this.addNode(new AutomationUnlockSkillNode('prestigeAutomationUnlock', 'Auto Prestige', 'Earn Prestige', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values.prestigeAutomationUnlocked));

        cost += inc;

        const prestigeAutomationBonus1 = this.addNode(new UpgradePrestigeAutomationSkillNode('prestigeAutomationBonus1', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values.prestigeAutomationRateUpgrades
        ));

        cost += inc;

        const prestigeAutomationBonus2 = this.addNode(new UpgradePrestigeAutomationSkillNode('prestigeAutomationBonus2', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values.prestigeAutomationRateUpgrades
        ));

        cost += inc;

        const prestigeAutomationBonus3 = this.addNode(new UpgradePrestigeAutomationSkillNode('prestigeAutomationBonus3', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values.prestigeAutomationRateUpgrades
        ));

        cost += inc;

        const prestigeAutomationBonus4 = this.addNode(new UpgradePrestigeAutomationSkillNode('prestigeAutomationBonus4', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values.prestigeAutomationRateUpgrades
        ));

        cost += inc;

        const prestigeAutomationBonus5 = this.addNode(new UpgradePrestigeAutomationSkillNode('prestigeAutomationBonus5', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values.prestigeAutomationRateUpgrades
        ));

        cost += inc;

        const prestigeAutomationBonus6 = this.addNode(new UpgradePrestigeAutomationSkillNode('prestigeAutomationBonus6', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values.prestigeAutomationRateUpgrades
        ));

        cost += inc;

        const prestigeAutomationBonus7 = this.addNode(new UpgradePrestigeAutomationSkillNode('prestigeAutomationBonus7', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values.prestigeAutomationRateUpgrades
        ));

        cost += inc;

        const prestigeAutomationBonus8 = this.addNode(new UpgradePrestigeAutomationSkillNode('prestigeAutomationBonus8', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values.prestigeAutomationRateUpgrades
        ));

        cost += inc;

        const prestigeAutomationBonus9 = this.addNode(new UpgradePrestigeAutomationSkillNode('prestigeAutomationBonus9', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values.prestigeAutomationRateUpgrades
        ));

        cost += inc;

        const prestigeAutomationBonus10 = this.addNode(new UpgradePrestigeAutomationSkillNode('prestigeAutomationBonus10', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values.prestigeAutomationRateUpgrades
        ));

        cost += inc;

        const prestigeAutomationBonus11 = this.addNode(new UpgradePrestigeAutomationSkillNode('prestigeAutomationBonus11', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values.prestigeAutomationRateUpgrades
        ));

        cost += inc;

        const prestigeAutomationBonus12 = this.addNode(new UpgradePrestigeAutomationSkillNode('prestigeAutomationBonus12', 
            totals, Images.currency.prestige, new BigNum(cost), this, this.values.prestigeAutomationRateUpgrades
        ));


        prestigeAutomationUnlock.addChildNode(prestigeAutomationBonus1);

        prestigeAutomationBonus1.addChildNode(prestigeAutomationBonus2);
        prestigeAutomationBonus2.addChildNode(prestigeAutomationBonus3);
        prestigeAutomationBonus3.addChildNode(prestigeAutomationBonus4);
        prestigeAutomationBonus4.addChildNode(prestigeAutomationBonus5);
        prestigeAutomationBonus5.addChildNode(prestigeAutomationBonus6);
        prestigeAutomationBonus6.addChildNode(prestigeAutomationBonus7);
        prestigeAutomationBonus7.addChildNode(prestigeAutomationBonus8);
        prestigeAutomationBonus8.addChildNode(prestigeAutomationBonus9);
        prestigeAutomationBonus9.addChildNode(prestigeAutomationBonus10);
        prestigeAutomationBonus10.addChildNode(prestigeAutomationBonus11);
        prestigeAutomationBonus11.addChildNode(prestigeAutomationBonus12);

        ///////////////////////////////////
        // Position the nodes in the graph
        ///////////////////////////////////

        // Starting coordinate of the skill
        const startX = -1;
        const startY = 11;

        prestigeAutomationUnlock.setPosition(startX, startY);

        prestigeAutomationBonus1.setPosition(startX - 1, startY);
        prestigeAutomationBonus2.setPosition(startX - 2, startY);
        prestigeAutomationBonus3.setPosition(startX - 3, startY);
        prestigeAutomationBonus4.setPosition(startX - 4, startY);
        prestigeAutomationBonus5.setPosition(startX - 5, startY);
        prestigeAutomationBonus6.setPosition(startX - 6, startY);
        prestigeAutomationBonus7.setPosition(startX - 6, startY - 1);
        prestigeAutomationBonus8.setPosition(startX - 5, startY - 1);
        prestigeAutomationBonus9.setPosition(startX - 4, startY - 1);
        prestigeAutomationBonus10.setPosition(startX - 3, startY - 1);
        prestigeAutomationBonus11.setPosition(startX - 2, startY - 1);
        prestigeAutomationBonus12.setPosition(startX - 1, startY - 1);

    }
    
}